import { DataObject } from '@/utils/DataObject';
import { Media } from './Media';

export class MediaTransformer {

  public toClass(data: DataObject = {}): Media {
    if (!data) {
      return { url: '/static/img/placeholder.png' };
    }
    return new Media({
      id: data.id,
      url: data.url,
      color: data.color,
      srcset: data.srcset,
      base64: data.base64,
    })
  }

}
